// extracted by mini-css-extract-plugin
var _1 = "DashboardListRow-modulebefore__md4ho";
var _2 = "DashboardListRow-moduledot__iOzKQ";
var _3 = "DashboardListRow-moduleleading__f6RJs";
var _4 = "DashboardListRow-modulemain__K1d9F";
var _5 = "DashboardListRow-modulerow__akHh2";
var _6 = "DashboardListRow-modulestatus__nkOqt";
var _7 = "DashboardListRow-modulesubtitle__KWZW8";
var _8 = "DashboardListRow-modulesubtitleLine__oCoJa";
var _9 = "DashboardListRow-moduletags__qZOB_";
var _a = "DashboardListRow-moduletitle__RAtnH";
var _b = "DashboardListRow-moduletrailing__LXgR7";
export { _1 as "before", _2 as "dot", _3 as "leading", _4 as "main", _5 as "row", _6 as "status", _7 as "subtitle", _8 as "subtitleLine", _9 as "tags", _a as "title", _b as "trailing" }
